var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9997 0.333496C10.0613 0.333496 0.333008 10.0618 0.333008 22.0002C0.333008 33.9385 10.0613 43.6668 21.9997 43.6668C33.938 43.6668 43.6663 33.9385 43.6663 22.0002C43.6663 10.0618 33.938 0.333496 21.9997 0.333496ZM32.3563 17.0168L20.0713 29.3018C19.768 29.6052 19.3563 29.7785 18.923 29.7785C18.4897 29.7785 18.078 29.6052 17.7747 29.3018L11.643 23.1702C11.0147 22.5418 11.0147 21.5018 11.643 20.8735C12.2713 20.2452 13.3113 20.2452 13.9397 20.8735L18.923 25.8568L30.0597 14.7202C30.688 14.0918 31.728 14.0918 32.3563 14.7202C32.9847 15.3485 32.9847 16.3668 32.3563 17.0168Z",
    fill: "url(#paint0_linear_8278_13165)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8278_13165",
    x1: 21.9997,
    y1: 0.333496,
    x2: 21.9997,
    y2: 43.6668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CC7A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1EA771"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.24b098c9.svg";
export { ForwardRef as ReactComponent };